<template>
  <div class="review_list">
    <div class="title pdlr20">
      <h2>
        <span class="back_btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
        </span>
        {{competition.competition_name}}比赛作品
      </h2>
    </div>
    <div class="pd20">
      <myTable class="mt20" :tableObj="tableObj" @btnClick="btnClick" @changePageNo="changePage"></myTable>
      <el-button type="primary" @click="submitMark" v-if="!competition.is_submit">全部评完，提交</el-button>
    </div>
  </div>
</template>

<script>
import myTable from "@/components/my_table";
export default {
  components: {
    myTable
  },
  data() {
    return {
      row: null, //临时操作对象
      competition:{},
      tableObj: {
        list: [], //列表数据
        btnsWidth: "100px",
        btns: [
          //按钮组
          {
            name: "评分",
            funcName: "detail",
            formatter:()=>{
              return !this.competition.is_submit
            }
          }
        ],
        table_detail: [
          {
            label: "作品",
            formatter: row => {
              console.log(row);
              return `<div style="display:flex;align-items:center;"><img style="width: 97px; height: 72px;object-fit:cover;" src="${row.opus_coverPath}"/>
              <div style="
              font-size: 14px;color:#333;
              margin-left:20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;">${row.opus_name}</div>
              </div>`;
            }
          },
          {
            width: "100px",
            prop: "total_point",
            label: "得分",
            formatter: row => {
              return row.total_point === "" ? "未评分" : row.total_point;
            }
          }
        ],
        layerpageinfo: {
          pageNo: 0,
          total: 0,
          pageSize: 10
        }
      }
    };
  },
  created() {
    this.initPage();
  },
  methods: {
    async initPage(){
      await this.getCompetitionsByJudge();//评委查询自己参评比赛
      await this.getJudgeAllotOpuses();// 评委查询已分配作品
    },
    submitMark(id) {
      return new Promise(resolve => {
        this.$confirm("确定全部评完提交?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let params = {
              judge: this.$route.query.id
            };
            this.api.submitMark(params).then(res => {
              if (res.error.err_code !== 0) return;
              this.initPage();
              resolve();
            });
          })
          .catch(() => {
            resolve();
          });
      });
    },
    go(name) {
      this.$router.push({
        name: name
      });
    },
    // 评委查询已分配作品
    getJudgeAllotOpuses() {
      let params = {
        judge: this.$route.query.id
      };
      return new Promise(resolve => {
        this.api.getJudgeAllotOpuses(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.tableObj.list = res.obj.list || [];
          this.tableObj.layerpageinfo.total = res.obj.totalSize;
          resolve();
        });
      });
    },
    // 评委查询自己参评比赛
    getCompetitionsByJudge() {
      let params = {
        id: this.$route.query.id
      };
      return new Promise(resolve => {
        this.api.getCompetitionsByJudge(params).then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list || [];
          this.competition = list.length?list[0]:{};
          resolve();
        });
      });
    },
    // 按钮组
    btnClick(btn) {
      this.row = btn.row;
      switch (btn.btnFuncName) {
        case "detail":
          console.log('sssssssssssssss')
          // 查看详情
          this.$router.push({
            name: "personal_center_judge_scoring",
            query: {
              opus: btn.row.opus,
              judge: btn.row.judge,
            }
          });
          break;
      }
    },

    // 改变页数
    changePage(obj) {
      this.tableObj.layerpageinfo.pageNo = obj.val;
      this.getJudgeAllotOpuses();
    }
  }
};
</script>

<style lang="scss" scoped>
.review_list {
  background: #fff;
  background: #fff;
  .title {
    padding: 20px 30px;
    h2 {
      display: flex;
      align-items: center;
      .back_btn {
        display: inline-block;
        width: 38px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #dcdfe6;
        margin-right: 14px;
        cursor: pointer;
        vertical-align: top;
      }
    }
    border-bottom: 1px solid #eeeeee;
  }
  .title::before {
    display: none;
  }
}
</style>